/***
 * Accordion for the salon menu page
 */
var acc = document.getElementsByClassName("options-panel-btn");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(e) {
        e.preventDefault()
        this.classList.toggle("active");
        var panel = this.parentNode.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

if(window.innerWidth <= 768) {
    var acc = document.getElementsByClassName("options-panel-header");
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function(e) {
            e.preventDefault()
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            console.log(panel)
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }
}